import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../assets/styles/GlobalStyles';

const ErrorContainer = styled.div`
  text-align: center;
  padding: 3rem;
  
  p {
    color: ${colors.red};
    margin-bottom: 1.5rem;
    font-size: 1.1rem;
  }
  
  button {
    padding: 0.75rem 1.5rem;
    background: ${colors.darkBlue};
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-weight: 500;
    font-family: inherit;

    &:hover {
      background: ${colors.blueMedium};
      transform: translateY(-2px);
    }
  }
`;

export const ProfileError = ({ error, onRetry }) => (
  <ErrorContainer>
    <p>❌ {error}</p>
    <button onClick={onRetry}>Tentar novamente</button>
  </ErrorContainer>
);